module.exports = __webpack_public_path__ + "img/Ensino-Personalizado-1300x350.efaff8d1.png";